define([], function () {

    function getPosition(el) {
        var win = el.ownerDocument.defaultView;
        var rect = el.getBoundingClientRect();

        if (!el.offsetParent) return { top: 0, left: 0, width: 0, height: 0};

        return {
            top: rect.top + win.pageYOffset,
            left: rect.left + win.pageXOffset,
            width: rect.width,
            height: rect.height
        }
    }

    function empty(el) {
        if (!el) return;
        while (el.lastChild) {
            el.removeChild(el.lastChild);
        }
    }

    return {
        getPosition: getPosition,
        empty: empty
    };

});
